import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              Welcome to Cafe.WebReady24
            </h1>
            <p className="hero-subtitle">
              The ultimate multi-restaurant food ordering platform. 
              Register your restaurant or order from your favorite local eateries.
            </p>
            <div className="hero-actions">
              <Link to="/register" className="btn  btn-lg" style={{ backgroundColor: "#C0E218", color: "#fff" }}>
                Register Your Restaurant
              </Link>
              <Link to="/login" className="btn btn-secondary btn-lg" style={{ backgroundColor: "#C0E218", color: "#fff" }}>
                Restaurant Login
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works">
        <div className="container">
          <h2 className="section-title">How It Works</h2>
          
          <div className="steps">
            <div className="step">
              <div className="step-number"  style={{ backgroundColor: "#C0E218", color: "#fff" }}>1</div>
              <h3>For Restaurant Owners</h3>
              <p>Register your restaurant, set up your menu, and start receiving orders online. Manage everything from your dashboard.</p>
              <ul>
                <li>Easy registration with unique shop URL</li>
                <li>Complete menu management</li>
                <li>Real-time order tracking</li>
                <li>Customer relationship management</li>
                <li>Sales analytics and reporting</li>
              </ul>
            </div>

            <div className="step">
              <div className="step-number"  style={{ backgroundColor: "#C0E218", color: "#fff" }}>2</div>
              <h3>For Customers</h3>
              <p>Discover amazing local restaurants and order your favorite food with just a few clicks.</p>
              <ul>
                <li>Browse restaurants by unique URLs</li>
                <li>Easy online ordering</li>
                <li>Track your order status</li>
                <li>One-time customer registration per restaurant</li>
                <li>Quick reordering for returning customers</li>
              </ul>
            </div>

            <div className="step">
              <div className="step-number"  style={{ backgroundColor: "#C0E218", color: "#fff" }}>3</div>
              <h3>Get Started Today</h3>
              <p>Join our platform and take your restaurant online or discover new dining options in your area.</p>
              <div className="step-actions">
                <Link to="/register" className="btn "  style={{ backgroundColor: "#C0E218", color: "#fff" }}>
                  Register Restaurant
                </Link>
                <p className="text-muted">
                  Already have a restaurant? <Link to="/login"  style={{ color: "#C0E218" }}>Login here</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <h2 className="section-title">Why Choose Cafe.WebReady24?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🚀</div>
              <h3>Easy Setup</h3>
              <p>Get your restaurant online in minutes with our simple registration process.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">💼</div>
              <h3>Complete Management</h3>
              <p>Full control over your menu, orders, customers, and store settings.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">📱</div>
              <h3>Mobile Friendly</h3>
              <p>Works perfectly on all devices - desktop, tablet, and mobile.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">🔒</div>
              <h3>Secure & Reliable</h3>
              <p>Enterprise-grade security and 99.9% uptime guarantee.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Powerful Analytics</h3>
              <p>Track your performance with detailed reports and insights.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">🎨</div>
              <h3>Customizable</h3>
              <p>Brand your store with custom colors and logos.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;